import { RagChip } from "@/components/ui/rag";
import { professionalFinding } from "@/lib/assessmentLogic";

/*
  Phase 8D — Client-facing evidence table.
  The "Note" column has been renamed "Finding" and now renders a
  deterministic professional finding synthesised from structured fields
  only. Raw consultantNotes, evidenceNote, and notApplicableReason values
  are never rendered by this component.
*/
export function ReportEvidenceTable({ items }) {
  return (
    <div className="overflow-hidden rounded-sm border border-border bg-card">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr className="text-left">
            <th className="w-10 px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">#</th>
            <th className="px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Item</th>
            <th className="w-16 px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Domain</th>
            <th className="w-28 px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Answer</th>
            <th className="w-24 px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Status</th>
            <th className="px-3 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Finding</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {items.map((item) => (
            <tr key={item.id}>
              <td className="px-3 py-3 align-top font-mono-label text-[11px] text-muted-foreground">
                {String(item.number).padStart(2, "0")}
              </td>
              <td className="px-3 py-3 align-top">
                <p className="font-display text-[15px] font-medium leading-tight text-foreground">
                  {item.title}
                </p>
              </td>
              <td className="px-3 py-3 align-top">
                <span className="letter-mark inline-flex h-6 w-6 text-[11px]">{item.domain}</span>
              </td>
              <td className="px-3 py-3 align-top text-foreground/85">{item.shortLabel}</td>
              <td className="px-3 py-3 align-top">
                <RagChip rag={item.rag} />
                {item.canonicalState && (
                  <p
                    className="font-mono-label mt-1 text-[10px] uppercase tracking-[0.18em] text-foreground"
                    data-testid={`report-canonical-state-${item.id}`}
                  >
                    {item.canonicalState}
                  </p>
                )}
              </td>
              <td
                className="px-3 py-3 align-top text-xs leading-relaxed text-muted-foreground"
                data-testid={`report-finding-${item.id}`}
              >
                {professionalFinding(item)}
                {item.fieldVerificationLabel && (
                  <p
                    className="font-mono-label mt-1 text-[10px] uppercase tracking-[0.18em] text-muted-foreground"
                    data-testid={`report-field-verification-${item.id}`}
                  >
                    Field verification · {item.fieldVerificationLabel}
                    {item.fieldVerification === "source_required" &&
                      " — this item may require supporting evidence before it can be relied on."}
                  </p>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
